import React from "react";
import { IonBackButton, IonButton, IonButtons, IonHeader, IonImg, IonToolbar } from "@ionic/react";
import { Button_Audio_Play_White, Button_Audio_Stop } from "@assets/images";
import { Capacitor } from "@capacitor/core";
import DataController from "@controllers/DataController";
import { IAccessibilitySettings } from "@interfaces/Interfaces";

interface ReadEvidenceHeaderProps {
  accessibilitySettings: IAccessibilitySettings | null;
  canEdit: boolean;
  playing: boolean;
  onTTSClick: () => void;
  onEditClick: () => void;
}

const ReadEvidenceHeader: React.FC<ReadEvidenceHeaderProps> = ({
  accessibilitySettings,
  canEdit,
  playing,
  onTTSClick,
  onEditClick,
}) => {
  return (
    <IonHeader>
      <IonToolbar
        mode="ios"
        className="navBar"
        style={{
          maxWidth: DataController.isWeb() ? 980 : undefined,
          height: Capacitor.getPlatform() === "android" ? "54px" : "unset",
        }}
      >
        <IonButtons slot="start">
          <IonBackButton
            className="header-back-buttons"
            defaultHref="/evidence"
            text={DataController.getBackIconText()}
            icon={DataController.getBackIconType()}
            style={{
              marginLeft: Capacitor.getPlatform() === "android" ? 8 : 0,
              "--icon-font-size": Capacitor.getPlatform() === "android" ? "24px" : "30px",
            }}
          />
        </IonButtons>
        <IonButtons slot="end">
          {accessibilitySettings?.textToSpeech && (
            <IonButton
              className="header-button"
              mode="ios"
              onClick={onTTSClick}
            >
              <IonImg
                src={playing ? Button_Audio_Stop : Button_Audio_Play_White}
                className="headerIcon"
              />
            </IonButton>
          )}
          {canEdit && (
            <IonButton
              mode="ios"
              className="cancelButton"
              onClick={onEditClick}
            >
              {"Edit"}
            </IonButton>
          )}
        </IonButtons>
      </IonToolbar>
    </IonHeader>
  );
};

export default ReadEvidenceHeader;
